import { Platform, PlatformOrigin } from '@/types/platform'

export const getRoutePlatformOrigin = (routePath: string) => {
  const platform = routePath.slice(1).split('/')[0]

  if (!Object.values(Platform).some((v) => v === platform)) {
    return
  }

  return PlatformOrigin[platform as Platform]
}
